export default __webpack_public_path__ + "static/media/img_5.c03bc979.png";